import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../../environments/environment.dev';

@Pipe({
  name: 'imgUrl',
  standalone: true
})
export class ImgUrlPipe implements PipeTransform {

  transform(path: string | undefined | null): string {
    if (!path) {
      return 'assets/images/no-image.png'; 
    }

    if (path.startsWith('http')) {
      return path;
    }

    return `${environment.baseUrl}${path}`;
  }
}